angular
  .module("advacedSearchHome.components", [])
  .component("advacedSearchHome", {
    templateUrl: "ng/components/advacedSearchHome/advacedSearchHome.html",
    bindings: {
      options: "=",
      rif: "=",
      onOutputReturns: "&?",
      page: "=",
      modeExport: "="
    },
    controllerAs: "advacedSearchHomeCtrl",
    controller: advacedSearchHomeController
    
  })
    function advacedSearchHomeController(
      $rootScope,
      HttpService,
      $configService,
      $scope,
      $simulationService

    ) {
      var self = this;

      self.$configService = $configService;

      self.$onInit = function () {

        self.rif = self.rif;

        self.typeUser = $configService.getUser().type;
        var page = self.page;

        self.modeExport = self.modeExport;

        self.filter = {
          limit: window.innerHeight > 620 ? '6' : '4',
          pageIndex: 1,
          offset: 0,
          totalPages: 0,
          orderColumnName: "INSERT_DATE",
          orderType: "DESC",
          showAllPreIstr: false
        };


        self.search(page);
        self.mapPracticeStatus = [];
        self.listaContractStatus = {};
        self.practiceStatusList = [];
        self.mapContractStatus = {};
        if (page == "inner-view-wftosign") {
          self.getContractStatusListFE();
        }

        self.context = $rootScope.context;
      };
      self.search = function (page) {
        if (page == "inner-view-wfactives") {
          self.searching = true;
          console.log("sto facendo la ricerca sulle simulazione");
          self.searching = true;
          self.filterSimulation();
        }

        if (page == "inner-view-wftosign") {
          console.log("sto facendo la ricerca sui contratti");
          self.filterContract();
        }
      };
      self.getContractStatusListFE = function () {
        HttpService.send(
          "/uni/typedomain/getDomainSet", {
            table: "APP_CONTRACT_FE",
            column: "STATUS_FE_REMAP"
          },
          false
        ).then(function (response) {
          self.listaContractStatusFE = response.domainList;

          angular.forEach(self.listaContractStatusFE, function (item) {
            if (propMap[item.name] != undefined) {
              item.name = propMap[item.name];
              
            }

          });
        });
      };

      self.mapContractStatus = {};

   

      // angular.forEach(self.contractStatusList, function (item) {
      //   switch (item.value) {
      //     case $rootScope.propMap["CONTRACT_STATUS_SPRINT_START"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_SPRINT_END"]:
      //       // IN LAVORAZIONE ALBA
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value == $rootScope.propMap["CONTRACT_STATUS_CREATED"]
      //         );
      //       }).name;
      //       break;
            
      //     case $rootScope.propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE"]:
      //     case $rootScope
      //       .propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_CONFIRMED_SIGNATURE"]:
      //     case $rootScope.propMap['CONTRACT_STATUS_WAITING_FOR_SIGNATURE']:
      //       //DELIBERATO
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value == $rootScope.propMap["CONTRACT_STATUS_DELIBERATED"]
      //         );
      //       }).name;
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_CONTRACT_STIPULATED"]:
      //     case $rootScope
      //       .propMap["CONTRACT_STATUS_CONTRACT_STIPULATED_FINAL"]:
      //       //SIGNED
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = "CONTRACT_STIPULATED_FINAL";
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_RED"]:
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value == $rootScope.propMap["CONTRACT_STATUS_RED"]
      //         );
      //       }).name;
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_WAITING_ADJ_DOC"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_DELIVERED_ADJ_DOC"]:
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = "LBL_ISTRUTTORIA";
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_DOCUMENT_ERROR"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_DELIVERED_REVISED_DOCUMENT"]:
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = "LBL_SUSPENDED";
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_EXPIRED"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_CONTRACT_CANCELLED"]:
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = "LBL_CONTRACT_ERASED";
      //       break;
      //     default:
      //       $scope.mapContractStatus[item.value] = item.name;
      //       break;
      //   }
      // });

      // angular.forEach(self.contractStatusList, function (item) {
      //   switch (item.value) {
      //     //case $rootScope.propMap['CONTRACT_STATUS_CREATED']:
      //     //IN LAVORAZIONE ALBA
      //     //self.mapContractStatus[item.value] = self.contractStatusList.find(function(el){
      //     //	return el.value==$rootScope.propMap['CONTRACT_STATUS_DELIVERED_PEF_DOC'];
      //     //}).name;
      //     //break;
      //     case $rootScope.propMap["CONTRACT_STATUS_SPRINT_START"]:
      //     case $rootScope.propMap["CONTRACT_STATUS_SPRINT_END"]:
      //       // IN LAVORAZIONE ALBA
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value == $rootScope.propMap["CONTRACT_STATUS_CREATED"]
      //         );
      //       }).name;
      //       break;
      //     case $rootScope
      //     .propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE"]:
      //     case $rootScope
      //     .propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED"]:
      //     case $rootScope
      //     .propMap["CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE"]:
      //       //DELIBERATO
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value ==
      //           $rootScope.propMap["CONTRACT_STATUS_DELIBERATED"]
      //         );
      //       }).name;
      //       break;
      //     case $rootScope.propMap["CONTRACT_STATUS_CONTRACT_STIPULATED"]:
      //     case $rootScope
      //     .propMap["CONTRACT_STATUS_CONTRACT_STIPULATED_FINAL"]:
      //       //SIGNED
      //       $scope.mapContractStatus[
      //         item.value
      //       ] = self.contractStatusList.find(function (el) {
      //         return (
      //           el.value == $rootScope.propMap["CONTRACT_STATUS_SIGNED"]
      //         );
      //       }).name;
      //       break;
      //     default:
      //       $scope.mapContractStatus[item.value] = item.name;
      //       break;
      //   }
      // });
      // console.log("self.contractStatusList: ", self.contractStatusList);



      /*  self.getTotalPages = function(totalCount) {
        //se il resto è zero non va aggiunto +1
        var addPlusOneToTotal = 0;
        var totModuloResult = totalCount % Number($scope.filter.limit);
        if (totModuloResult > 0) {
          addPlusOneToTotal = 1;
        }
        return (
          Math.floor(totalCount / Number($scope.filter.limit)) +
          addPlusOneToTotal
        );
      }; */

      var validateInput = function () {
        if (!filter.pivaCustomer) {
          $rootScope.$broadcast("addAlert", {
            text: "LOGIN_LANDINGPAGE_003"
          });
        }
        return self.filter.pivaCustomer;
      }

      //update table getAllContracts
      self.updateOrderTableContracts = function (ordColName, ordType) {
        self.filter.orderColumnName = ordColName;
        self.filter.orderType = ordType;
        self.searchContracts();
      }

      self.filterContract = function () {

        self.input = self.filter;
        self.onOutputReturns({
          input: self.input
        });
      }

      self.filterSimulation = function () {
        self.input = self.filter;
        self.onOutputReturns({
          input: self.input
        });
      }

      self.enableButton = function(){
        /*
        var pivaCustomerIsValid = $scope.HomeAdvancedSearchForm && 
        $scope.HomeAdvancedSearchForm.inputPivaCustomer &&
        $scope.HomeAdvancedSearchForm.inputPivaCustomer.$valid;

        var pivaVendorIsValid = $scope.HomeAdvancedSearchForm &&
        $scope.HomeAdvancedSearchForm.inputPiva &&
        $scope.HomeAdvancedSearchForm.inputPiva.$valid;

        return !!self.filter.startInsertDate ||
        !!self.filter.finishInsertDate ||
        !!self.filter.idContract ||
        !!self.filter.status ||
        !!self.filter.ragSocCustomer ||
        (!!self.filter.pivaCustomer && pivaCustomerIsValid)  ||
        !!self.filter.nameVendor ||
        (!!self.filter.pivaVendor && pivaVendorIsValid)
        */
      }

      self.getExportExcelContracts = function () {

        self.isLoadingExportContracts = true;
  
        $simulationService
          .getExportExcelContracts(self.filter)
          .then(function (response) {
            console.log("RESPONSE: ", response);
          })
          .catch(function (error) {
            console.log("ERROR", error);
            self.isLoadingExportContracts = false;
  
          })
          .finally(function () {
            console.log("getExportExcelContracts done!");
            self.isLoadingExportContracts = false;
          })
      }
  
      self.getExportExcelSimulations = function () {
  
        self.isLoadingExportSimulations = true;
  
        $simulationService
          .getExportExcelSimulations(self.filter)
          .then(function (response){
            console.log("RESPONSE: ", response);
          })
          .catch(function (error) {
            console.log("RESPONSE", error);
            self.isLoadingExportSimulations = false;
          })
          .finally(function () {
            console.log("getExportExcelContracts done!");
            self.isLoadingExportSimulations = false;
          })
      }

      self.check = function(el){
        el.showAllPreIstr = !el.showAllPreIstr;
      }

    }
